import PouchDB from "pouchdb";

export interface PouchOptions {
  enabled?: boolean;
}

export type PouchDocument<T> = T & // new (possibly with client-supplied ID)
  (
    | (Partial<PouchDB.Core.IdMeta> & { _rev?: undefined; _deleted?: undefined })
    // existing
    | (PouchDB.Core.IdMeta & PouchDB.Core.RevisionIdMeta & PouchDB.Core.ChangesMeta)
  );

export function isPouchError(
  error: any
): error is { error: true; message: string; name: string; reason: string; status: number; stack: string } {
  return (
    ["message", "name", "reason", "stack"].every((key) => key in error && typeof error[key] === "string") &&
    "error" in error &&
    typeof error.error === "boolean" &&
    "status" in error &&
    typeof error.status === "number"
  );
}
